export default function resetInputValue(
  element: HTMLInputElement | HTMLTextAreaElement | null,
) {
  if (element) {
    element.placeholder = "";
    if (element.type === "checkbox" && element instanceof HTMLInputElement) {
      element.checked = false;
    } else {
      element.value = "";
    }
    const dataFrameString = element.dataset.frame;
    if (dataFrameString) {
      const dataFrame = Number.parseInt(dataFrameString, 10); // Convert to number
      const currentElementState = window.pplr_values[dataFrame][93];
      if (currentElementState) {
        currentElementState.text_val = "";
        // Create a synthetic event
        element.dispatchEvent(
          new Event("input", {
            bubbles: true,
            cancelable: false,
          }),
        );
      }
    }
  }
}
